<template>
  <svg
    class="guidedTourIcon productIcon"
    viewBox="0 0 83 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 1.41421;
    "
  >
    <g>
      <g id="Group-3">
        <path
          id="Shape"
          d="M57.564,21.771L68.937,27.898L69.274,27.232C69.424,26.932 69.349,26.632 69.125,26.407L60.066,18.911C59.692,18.611 59.094,18.686 58.795,19.211L57.564,21.771Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          id="Shape1"
          serif:id="Shape"
          d="M67.495,29.456L54.409,22.781"
          style="fill: none; stroke: black; stroke-width: 1.8px"
          class="hasStroke"
        />
        <path
          id="Shape2"
          serif:id="Shape"
          d="M56.66,24.25L68.27,29.971C68.27,29.971 68.182,30.328 68.117,30.525C67.145,34.125 63.481,36.225 59.892,35.25C56.303,34.275 54.209,30.6 55.181,27C55.461,25.987 56.66,24.25 56.66,24.25Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          id="Shape3"
          serif:id="Shape"
          d="M38.282,36L55.912,35.982C58.068,37.514 60.511,38.525 64.011,37.688L77.389,54.825C78.212,55.875 78.062,57.525 77.015,58.35C76.567,58.725 76.043,58.875 75.445,58.875C74.697,58.875 73.949,58.575 73.501,57.9L65.724,48.075L65.201,59.1L49.722,57.9L52.639,42.225C52.639,41.85 52.713,41.4 52.863,41.025L38.282,41.025C36.936,41.025 35.814,39.9 35.814,38.55C35.814,37.2 36.936,36 38.282,36Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          id="Shape4"
          serif:id="Shape"
          d="M56.045,84.758L64.046,84.758L63.556,61.45L52.788,60.7L56.045,84.758Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          id="Shape5"
          serif:id="Shape"
          d="M59.518,89.4L66.322,89.4C66.771,89.4 66.995,88.875 66.696,88.5L65.051,86.7L60.64,86.7L59.518,89.4Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          id="Shape6"
          serif:id="Shape"
          d="M51.517,89.4L58.097,89.4C58.322,89.4 58.471,89.25 58.546,89.1L59.294,87.3C59.443,87 59.219,86.625 58.845,86.625L55.331,86.625C55.256,86.625 55.181,86.625 55.106,86.7L51.367,88.5C50.919,88.725 51.068,89.4 51.517,89.4Z"
          style="fill-rule: nonzero"
          class="hasFill"
        />
        <path
          d="M29.295,9.32L29.458,9.336L29.619,9.363L29.779,9.4L29.935,9.448L30.088,9.505L30.237,9.573L30.382,9.65L30.521,9.736L30.654,9.832L30.78,9.935L30.899,10.047L31.011,10.167L31.115,10.293L31.21,10.426L31.297,10.565L31.374,10.709L31.441,10.858L31.499,11.011L31.546,11.168L31.584,11.327L31.61,11.489L31.626,11.651L31.632,11.815L31.632,38.883L31.626,39.046L31.61,39.209L31.584,39.37L31.546,39.53L31.499,39.686L31.441,39.839L31.374,39.988L31.297,40.133L31.21,40.271L31.115,40.404L31.011,40.531L30.899,40.65L30.78,40.762L30.654,40.866L30.521,40.961L30.382,41.048L30.237,41.125L30.088,41.192L29.935,41.25L29.779,41.297L29.619,41.334L29.458,41.361L29.295,41.377L29.132,41.383L8.831,41.383L8.667,41.377L8.505,41.361L8.343,41.334L8.184,41.297L8.027,41.25L7.874,41.192L7.725,41.125L7.581,41.048L7.442,40.961L7.309,40.866L7.183,40.762L7.063,40.65L6.951,40.531L6.848,40.404L6.752,40.271L6.666,40.133L6.589,39.988L6.521,39.839L6.464,39.686L6.416,39.53L6.379,39.37L6.352,39.209L6.336,39.046L6.331,38.883L6.331,11.815L6.336,11.651L6.352,11.489L6.379,11.327L6.416,11.168L6.464,11.011L6.521,10.858L6.589,10.709L6.666,10.565L6.752,10.426L6.848,10.293L6.951,10.167L7.063,10.047L7.183,9.935L7.309,9.832L7.442,9.736L7.581,9.65L7.725,9.573L7.874,9.505L8.027,9.448L8.184,9.4L8.343,9.363L8.505,9.336L8.667,9.32L8.831,9.315L29.132,9.315L29.295,9.32ZM8.831,11.815L8.831,38.883L29.132,38.883L29.132,11.815L8.831,11.815Z"
          class="hasFill"
        />
        <path
          d="M8.311,10.876L29.928,32.493"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
        <path
          d="M8.311,18.244L29.928,39.861"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
        <path
          d="M8.311,25.38L23.127,40.196"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
        <path
          d="M8.311,32.168L16.251,40.108"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
        <path
          d="M15.189,10.485L29.928,25.224"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
        <path
          d="M22.463,10.485L30.385,18.407"
          style="fill: none; stroke: black; stroke-width: 2px; stroke-miterlimit: 1.5"
          class="hasStroke"
        />
      </g>
    </g>
  </svg>
</template>
